/**
 * @typedef {Object} SubModules
 * @property {string} USER_MANAGEMENT
 * @property {string} HISTORY
 * @property {string} APPOINTMENTS
 * @property {string} PROCEDURES
 * @property {string} NOTES
 * @property {string} DOCUMENTATION
 * @property {string} ATTACHMENTS
 * @property {string} VITALS
 * @property {string} INVENTORY
 * @property {string} PRESCRIPTION
 * @property {string} INVOICE
 * @property {string} WAIVER
 * @property {string} QR_CODE
 * @property {string} PETS
 * @property {string} PET_OWNERS
 * @property {string} ITEMS
 * @property {string} ITEM_BUNDLES
 * @property {string} TRANSACTIONS
 * @property {string} SUPPLIERS
 * @property {string} CATEGORIES
 * @property {string} TRANSACTION_TYPES
 * @property {string} MEDICAL_HISTORY_REPORT
 * @property {string} APPOINTMENTS_REPORT
 * @property {string} REVENUE_REPORT
 * @property {string} INVENTORY_REPORT
 * @property {string} SERVICES_PRICE_LIST
 * @property {string} WAIVER_TEMPLATES
 * @property {string} FILE_MAINTENANCE
 * @property {string} SIGNATURE
 * @property {string} CLINIC_CONTACT_INFORMATION
 * @property {string} CLINIC_LOGO
 * @property {string} SWITCH_CLINIC_BRANCH
 */

/** @type {SubModules} */
export const SUB_MODULES = {
  USER_MANAGEMENT: "User Management",
  HISTORY: "History",
  APPOINTMENTS: "Appointments",
  PROCEDURES: "Procedures",
  NOTES: "Notes",
  DOCUMENTATION: "Documentation",
  ATTACHMENTS: "Attachments",
  VITALS: "Vitals",
  INVENTORY: "Inventory",
  PRESCRIPTION: "Prescription",
  INVOICE: "Invoice",
  WAIVER: "Waiver",
  QR_CODE: "QR Code",
  PETS: "Pets",
  PET_OWNERS: "Pet Owners",
  ITEMS: "Items",
  ITEM_BUNDLES: "Item Bundles",
  TRANSACTIONS: "Transactions",
  SUPPLIERS: "Suppliers",
  CATEGORIES: "Categories",
  TRANSACTION_TYPES: "Transaction Types",
  MEDICAL_HISTORY_REPORT: "Medical History Report",
  APPOINTMENTS_REPORT: "Appointments Report",
  REVENUE_REPORT: "Revenue Report",
  INVENTORY_REPORT: "Inventory Report",
  SERVICES_PRICE_LIST: "Services Price List",
  WAIVER_TEMPLATES: "Waiver Templates",
  FILE_MAINTENANCE: "File Maintenance",
  SIGNATURE: "Signature",
  CLINIC_CONTACT_INFORMATION: "Clinic Contact Information",
  CLINIC_LOGO: "Clinic Logo",
  SWITCH_CLINIC_BRANCH: "Switch Clinic Branch",
};
